import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage as flash } from "./../../../utils/flash/index";
import underwritingService from "./underwritingService";
import { current } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isSuccess: false,
  isFetching: false,
  isUpdated: false,
  isError: false,
  underwritingData: null,
  policyScheduleData: null,
  clauses: [],
};

const underwritingSlice = createSlice({
  initialState,
  name: "underwrite",
  reducers: {
    resetUnderwriting: (state) => initialState,
    resetUnderwritingStatus: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isUpdated = false;
      state.isFetching = false;
    },
    addClauses: (state, { payload }) => {
      const newClause = state.clauses?.findIndex(
        (item) => item.clause_id === payload.clause_id
      );
      if (newClause >= 0) {
        state.clauses[newClause] = payload;
      } else {
        state.clauses = [...state.clauses, payload];
      }
    },
    deleteClause: (state, { payload }) => {
      const clauses = state.clauses.filter((item) => item.clause_id != payload);
      state.clauses = clauses;
    },
    resetClauses: (state, { payload }) => {
      state.clauses = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUnderwritingData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnderwritingData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.underwritingData = payload;
      })
      .addCase(getUnderwritingData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(submitUnderwriting.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Submitting...");
      })
      .addCase(submitUnderwriting.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.policyScheduleData = payload;
        if (!payload.errors) {
          state.isSuccess = true;
          state.isUpdated = true;
          flash("success", `${payload.message}fuly undwritten`);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(submitUnderwriting.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getPolicyDocument.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPolicyDocument.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.policyScheduleData = payload;
        if (!payload.errors) {
          state.isSuccess = true;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getPolicyDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getPolicySavingsDocument.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPolicySavingsDocument.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.policyScheduleData = payload;
          state.isSuccess = true;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getPolicySavingsDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      // savings underwriting policy
      .addCase(getSavingsunderwritingData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSavingsunderwritingData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.underwritingData = payload;
        if (!payload.errors) {
          state.isSuccess = true;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getSavingsunderwritingData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(submitSavingsUnderwriting.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Submitting...");
      })
      .addCase(submitSavingsUnderwriting.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.policyScheduleData = payload;
        if (!payload.errors) {
          state.isSuccess = true;
          state.isUpdated = true;
          flash("success", `${payload.message}`);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(submitSavingsUnderwriting.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const getUnderwritingData = createAsyncThunk(
  "/underwriting/policy",
  async (DATA, thunkAPI) => {
    try {
      return await underwritingService.getUnderwritingData(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// submit underwriting data
export const submitUnderwriting = createAsyncThunk(
  "submitUnderwriting",
  async (DATA, thunkAPI) => {
    try {
      return await underwritingService.submitUnderwriting(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getPolicyDocument = createAsyncThunk(
  "getPolicyDocument",
  async (DATA, thunkAPI) => {
    try {
      return await underwritingService.getPolicyDocument(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

/**
 * savings policy underwriting
 */

export const getSavingsunderwritingData = createAsyncThunk(
  "getSavingsunderwritingData",
  async (DATA, thunkAPI) => {
    try {
      return await underwritingService.getSavingsunderwritingData(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const submitSavingsUnderwriting = createAsyncThunk(
  "submitSavingsUnderwriting",
  async (DATA, thunkAPI) => {
    try {
      return await underwritingService.submitSavingsUnderwriting(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPolicySavingsDocument = createAsyncThunk(
  "getPolicySavingsDocument",
  async (DATA, thunkAPI) => {
    try {
      return await underwritingService.getPolicySavingsDocument(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const {
  resetUnderwriting,
  resetUnderwritingStatus,
  addClauses,
  deleteClause,
  resetClauses,
} = underwritingSlice.actions;
export default underwritingSlice.reducer;
